import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import classes from "./PoLinkPayMethods.module.scss"

const PoLinkPayMethods = props => {
  const {
    paymentDetails,
    setPaymentDetails
  } = props

  const [t] = useTranslation()

  const handleClick = (method) => {
    setPaymentDetails(prev => ({
      ...prev,
      linkPayMethod:
        method !== prev.linkPayMethod ? method : ""
    }))
  }

  return (
    <div className={classes["container"]}>
      <div className={classes["title"]}>
        {t("ارسال_لینک_پرداخت")}
      </div>
      <div className={classes["row"]}>
        <button
          onClick={() => handleClick("SMS")}
          className={clsx(
            classes["method"],
            paymentDetails.linkPayMethod === "SMS" && classes["active"]
          )}
        >
          SMS
        </button>
        <button
          onClick={() => handleClick("whatsapp")}
          className={clsx(
            classes["method"],
            paymentDetails.linkPayMethod === "whatsapp" && classes["active"]
          )}
        >
          {t("واتساپ")}
        </button>
      </div>
    </div>
  )
}

export default PoLinkPayMethods